export default "__VITE_ASSET__196a0eee__"